export default {
  computed: {
    actionsPermission() {
      const permissions = this.$store.getters.getPermissions
      return { 
        create: permissions.includes(`${this.accessedArea}-create`),
        update: permissions.includes(`${this.accessedArea}-update`),
        delete: permissions.includes(`${this.accessedArea}-delete`)
      }
    }
  },
}
